var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.vouchers) ? _c('div', {
    attrs: {
      "data-testid": "visit-voucher-list"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.vouchers), function(p) {
    return [_c('tr', {
      staticClass: "row m-0",
      class: (p.status === 'ERROR' ? 'bg-danger-light' : ''),
      attrs: {
        "data-testid": 'visit-voucher-row-' + p.id
      }
    }, [_c('td', {
      staticClass: "text-left col-md-1"
    }, [_c('span', {
      staticClass: "font-weight-bold"
    }, [(p.status === 'UNPREPARED') ? _c('i', {
      staticClass: "fa fa-minus-circle text-warning",
      attrs: {
        "aria-hidden": "true",
        "data-testid": 'visit-voucher-status-' + p.id
      }
    }) : _vm._e(), _vm._v(" "), (p.status === 'ERROR') ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: p.last_evoucher_message,
          classes: ['danger', 'half']
        }),
        expression: "{\n                                              content: p.last_evoucher_message,\n                                              classes: ['danger', 'half']}"
      }],
      staticClass: "fa fa-exclamation-circle text-danger",
      attrs: {
        "aria-hidden": "true",
        "data-testid": 'visit-voucher-status-' + p.id
      }
    }) : _vm._e(), _vm._v(" "), (p.status === 'PREPARED') ? _c('i', {
      staticClass: "fa fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true",
        "data-testid": 'visit-voucher-status-' + p.id
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "green"
    }, [_vm._v("E")]), _vm._v("Poukaz\n                                   ")])]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-5"
    }, [_vm._v("\n                                    " + _vm._s(p.medical_device ? p.medical_device.label : '')), _c('br'), _vm._v("\n                                    " + _vm._s(p.medical_device ? p.medical_device.description : '') + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                                    " + _vm._s(p.disease !== null ? p.disease.code : '') + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                                    " + _vm._s(p.payment ? 'UHR' + p.payment : 'pacient') + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                                    " + _vm._s(p.quantity) + " " + _vm._s(p.temporary_duration_months ? '(na ' + p.temporary_duration_months + ' měs.)' : '') + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [(p.patient_notification_type === 'SMS') ? _c('span', [_vm._v("SMS")]) : (p.patient_notification_type === 'EMAIL') ? _c('span', [_vm._v("e-mail")]) : _c('span', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-left col-md-1"
    }, [(p.status !== 'DELETED') ? [(p.type === 'printed' || p.status === 'UNPREPARED') ? [_c('button', {
      staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
      attrs: {
        "data-testid": 'visit-voucher-delete-' + p.id
      },
      on: {
        "click": function($event) {
          _vm.removeVoucher(p)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.toDeleteElectronicPrescriptionId === p.id) ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.toDeleteElectronicPrescriptionReason),
        expression: "toDeleteElectronicPrescriptionReason"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "text",
        "aria-describedby": "reason",
        "id": "reason",
        "placeholder": "důvod zrušení eR.",
        "data-testid": 'visit-voucher-cancel-reason-' + p.id
      },
      domProps: {
        "value": (_vm.toDeleteElectronicPrescriptionReason)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.toDeleteElectronicPrescriptionReason = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
      attrs: {
        "data-testid": 'visit-voucher-delete-' + p.id
      },
      on: {
        "click": function($event) {
          _vm.removeVoucher(p)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : [(p.status === 'PREPARED') ? [_c('button', {
      staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
      attrs: {
        "data-testid": 'visit-voucher-delete-' + p.id
      },
      on: {
        "click": function($event) {
          _vm.setElectronicOPrescriptionToDelete(p.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e()], _vm._v(" "), (p.status === 'ERROR') ? [_c('button', {
      staticClass: "btn btn-sm btn-primary btn_line-heigh-1",
      attrs: {
        "data-testid": 'visit-voucher-retry-' + p.id
      },
      on: {
        "click": function($event) {
          _vm.sendToSuklElectronicVoucher(p.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-repeat",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e()] : [_c('span', {
      staticClass: "text-danger font-weight-bold"
    }, [_vm._v("SMAZÁNO")])]], 2)])]
  }), _vm._v(" "), (_vm.vouchers.length > 0) ? [_c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-md-5"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-left col-md-4 pt-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "data-testid": "visit-voucher-refresh"
    },
    on: {
      "click": function($event) {
        _vm.updateVouchers()
      }
    }
  }, [_vm._v("aktualizuj seznam")])])])] : _vm._e()], 2)])]) : (_vm.vouchersPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")]) : _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-testid": "visit-voucher-empty"
    }
  }, [_vm._v("\n            (žádný poukaz nebyl vypsán)\n        ")])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-md-5"
  }, [_vm._v("Lék")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Diag.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("úhrada")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Počet bal.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Notifikace")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3600ebe2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Voucher/ListVoucher.vue
// module id = 583
// module chunks = 0